import { useMemo } from 'react'
import { BufferGeometry, Mesh, Vector3 } from 'three'
import { useControlStore, useTapelineStore } from '@editorStores'
import { useDisposeThreeObjectsOnUnmount } from '@editorHooks'

/**
 * Midpoints of the visible tapelines, for DrawController point snapping.
 * Empty when tapelines are hidden or center snapping is switched off.
 */
const useTapelineCentersSnapTargets = (xyOnly = false) => {
  const isTapelineVisible = useTapelineStore(state => state.isVisible)
  const isTapelineActive = useTapelineStore(state => state.isActive)
  const tapelines = useTapelineStore(state => state.lines)
  const activeFilterViewId = useTapelineStore(state => state.activeFilterViewId)
  const snapToTapelineCenters = useControlStore(state => state.snapToTapelineCenters)

  const visibleTapelines = useMemo(
    () => tapelines.filter(tapeline => tapeline.filterViewId === activeFilterViewId),
    [tapelines, activeFilterViewId],
  )

  const snapTargets = useMemo(
    () =>
      (isTapelineVisible || isTapelineActive) && snapToTapelineCenters
        ? visibleTapelines.map(tapeline => {
            const center = new Vector3(tapeline.start.x, tapeline.start.y, tapeline.start.z)
              .add(new Vector3(tapeline.end.x, tapeline.end.y, tapeline.end.z))
              .multiplyScalar(0.5)

            if (xyOnly) {
              center.setZ(0)
            }

            return new Mesh(new BufferGeometry().setFromPoints([center]))
          })
        : [],
    [visibleTapelines, isTapelineVisible, isTapelineActive, snapToTapelineCenters, xyOnly],
  )

  useDisposeThreeObjectsOnUnmount(snapTargets)

  return snapTargets
}

export default useTapelineCentersSnapTargets
